import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { InFavouritesIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
};

const InFavouritesThemedIcon = ({ className, width, height, theme }) => (
  <InFavouritesIcon className={className} width={width} height={height} fill={theme.color.favourites} />
);

InFavouritesThemedIcon.propTypes = propTypes;

export default withTheme(InFavouritesThemedIcon);
